import React from 'react';
import { PhotoIcon } from '@heroicons/react/24/solid';
import ImageSelectModal from '../ProductImage/ImageSelectModal';
import { useVariantImage } from '../ProductImage/useVariantImage';
import { CardSection } from '../primitives';
import { Button } from '../primitives';

export interface IProductVariantEditorImageSectionProps {
    disabled?: boolean;
}

export const ProductVariantEditorImageSection: React.FC<IProductVariantEditorImageSectionProps> = ({ disabled = false }) => {
    const { variantImageId, variantImage, setVariantImageId, fetchMoreImages } = useVariantImage();
    const [isModalOpen, setIsModalOpen] = React.useState(false);

    const handleOpenModal = () => {
        fetchMoreImages(null);
        setIsModalOpen(true);
    };

    return (
        <CardSection>
            <div className="flex flex-col">
                {variantImageId ? (
                    <div className="relative">
                        <div className="w-40 h-40 bg-gray-100 rounded-md">
                            <img
                                src={variantImage?.thumbnailUrl}
                                alt="Product Image"
                                className="object-cover w-40 h-40"
                            />
                        </div>
                        {!disabled && (
                            <div>
                                <Button onClick={handleOpenModal} variant="link">
                                    Change
                                </Button>
                                <Button
                                    onClick={() => setVariantImageId(null)}
                                    variant="ghost"
                                    className="text-destructive hover:bg-destructive/10 hover:text-destructive"
                                >
                                    Remove
                                </Button>
                            </div>
                        )}
                    </div>
                ) : (
                    <div
                        className={`flex items-center justify-center h-40 w-40 rounded-md ${
                            disabled ? 'bg-white border border-gray-300' : 'bg-white hover:bg-gray-50 cursor-pointer border-2 border-dashed border-gray-300'
                        }`}
                        onClick={!disabled ? handleOpenModal : undefined}
                    >
                        {disabled ? (
                            <PhotoIcon className="w-20 h-20 text-gray-300" />
                        ) : (
                            <button name="add-button" className="add-button" type="button">
                                Add Image
                            </button>
                        )}
                    </div>
                )}
            </div>

            <ImageSelectModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                mode="single"
                selectedIds={variantImageId ? [variantImageId] : []}
                onDone={(ids) => setVariantImageId(ids[0] ?? null)}
            />
        </CardSection>
    );
};

export default ProductVariantEditorImageSection;
